import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { DadoAdicionalItemService } from 'src/app/shared/services/dado-adicional-item.service';
import { NavigationService } from '../../../services/navigation.service';

@Component({
  selector: 'app-dado-adicional-item-list',
  templateUrl: './dado-adicional-item-list.component.html',
  styleUrls: ['./dado-adicional-item-list.component.scss']
})
export class DadoAdicionalItemListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {

  dadosList: any[];

  constructor(
    private myService: DadoAdicionalItemService,
    private navigation: NavigationService
  ) {
    super()
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.myService.index().subscribe((res: any[]) => {
      this.dadosList = res;
      this.loaded();
    });
  }

  novo() {
    return ['/projetos/admin-spgg/dados-adicionais-item/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/dados-adicionais-item', id];
  }
}
